export default __webpack_public_path__ + "static/media/order-complete.51eec982.svg";